import { findApplicant, findChildren, findSpouse } from '@hc-frontend/business'
import { IMember, Gender } from '@hc-frontend/entities'
import startApplicationConfig from 'sites/enroll.pivothealth.com/start-application/config'

function makeProfile(member: IMember) {
  if (!member) {
    return undefined
  }

  const data = {
    Gender: member.gender === Gender.Male ? 'Male' : 'Female',
    DateOfBirth: member.stringDOB
  }

  if (member.firstName) {
    data['FirstName'] = member.firstName
  }

  if (member.lastName) {
    data['LastName'] = member.lastName
  }

  return data
}

function makeLastPivotPlanVisited(hcStorage) {
  if (!hcStorage.pivotPlan?.planId) {
    return null
  }

  const data = {
    PlanId: hcStorage.pivotPlan?.planId,
    Period: hcStorage.period,
    Policies: hcStorage.policies
  }

  return data
}

function makeQuestions(hcStorage) {
  if (!hcStorage.censusUrgency) {
    return null
  }

  return { coverage_start: hcStorage.censusUrgency }
}

function makePayload(hcStorage, config) {
  const Children = findChildren(hcStorage.members).map(makeProfile)
  const Couple = makeProfile(findSpouse(hcStorage.members))
  const HouseHoldSize = 1 + (Couple ? 1 : 0) + Children.length
  const isStartApplicationPage = config
    ? config.placement === startApplicationConfig.placement
    : false
  const lastPivotPlanVisited = isStartApplicationPage
    ? makeLastPivotPlanVisited(hcStorage)
    : null

  return {
    eventContext: {
      sessionId: hcStorage.healthcareSession,
      userId: hcStorage.healthcareUserId,
      src: hcStorage.source,
      placement: config ? config.placement : '',
      Device: hcStorage.Device,
      PublisherCampaignId: '',
      btsid: hcStorage.bt_sid, // cspell:disable-line
      subid: hcStorage.subid
    },
    geolocation: [
      {
        zipCode: hcStorage.location.zip_code,
        stateName: hcStorage.location.state,
        countyName: hcStorage.location.county,
        stateAcronym: hcStorage.location.state_acronym,
        city: hcStorage.location.city
      }
    ],
    applicantContext: {
      Product: 'Health',
      CensusUrgency: hcStorage.censusUrgency,
      ApplicantEmail: hcStorage.contact.email_address || '',
      HouseIncome: hcStorage.household.income,
      HouseHoldSize,
      SubsidyEligible: null,
      MedicaidEligible: null,
      Qle: hcStorage.life_event,
      qleSource: null,
      subsidy: hcStorage.subid,
      PhoneNumber: hcStorage.contact.phone_home,
      Address: hcStorage.contact.address,
      Holder: makeProfile(findApplicant(hcStorage.members)),
      LastPivotPlanVisited: lastPivotPlanVisited,
      Questions: makeQuestions(hcStorage),
      Couple,
      Children
    }
  }
}

export default makePayload
